import { types, getParent } from 'mobx-state-tree'

export const Operation = types.model({
    description: '',
    numberOfSetups: 1,
    minutesPerSetup: 30,
    numberOfOperations: 1,
    secondsPerOperation: 60,
    extraMinutesPerUnit: 0,
    comment: ''
  }).actions(self => ({
    setDescription(value) {
      self.description = value
    },
    setComment(value) {
      self.comment = value
    },
    setNumberOfSetups(number) {
      self.numberOfSetups = number
    },
    setMinutesPerSetup(number) {
      self.minutesPerSetup = number
    },
    setNumberOfOperations(number) {
      self.numberOfOperations = number
    },
    setSecondsPerOperation(number) {
      self.secondsPerOperation = number
    },
    setExtraMinutesPerUnit(number) {
      self.extraMinutesPerUnit = number
    },
    remove() {
      getParent(self, 2).removeItem(self)
    }
  })).views(self => ({
    get isValid() {
      return self.description.length > 0
    },
    get setupMinutes() {
      return self.minutesPerSetup * self.numberOfSetups
    },
    operationMinutes(qty) {
      return Math.ceil((self.numberOfOperations * self.secondsPerOperation) / 60)
    },
    extraMinutes(qty) {
      return self.extraMinutesPerUnit * self.qty
    },
    totalMinutes(qty) {
      return self.setupMinutes + self.operationMinutes(qty) + self.extraMinutes(qty)
    },
    totalDollars(qty, dollarsPerHour) {
      return self.totalMinutes(qty) / 60 * dollarsPerHour
    }
  }))



// WEBPACK FOOTER //
// ./src/models/Operation.js